import { I18n } from '@lingui/core';
import { t } from '@lingui/macro';

export const translateCode = (code: string, i18n: I18n) => {
  const map = {
    RETRY_DEVICE_DATA_FETCH: t(i18n)`Reintentando obtener datos del dispositivo`,
    ERROR_DEVICE_DATA_NOT_FOUND: t(i18n)`No se encontraron datos del dispositivo`,
    RETRY_WEBSITE_LOGIN: t(i18n)`Reintentando iniciar sesión en el sitio web`,
    ERROR_LOGIN_FAILED: t(i18n)`Error al iniciar sesión`,
    ERROR_WEBDRIVER_TIMEOUT: t(i18n)`Tiempo de espera agotado en la automatización web`,
    ERROR_SPECIFIC_DEVICE_DATA_NOT_FOUND: t(
      i18n,
    )`No se encontraron datos específicos del dispositivo`,
    INFO_NO_NEW_DEVICE_DATA: t(i18n)`No hay nuevos datos del dispositivo`,
    ERROR_CAPTA_API_UPLOAD_FAILED: t(i18n)`Error al subir datos a la API de Captcha`,
    ERROR_NO_FILES_FOUND: t(i18n)`No se encontraron archivos`,
    ERROR_UNKNOWN: t(i18n)`Error desconocido`,
    WRITTEN: t(i18n)`Datos escritos correctamente`,
    ERROR_SFTP_CONNECTION_FAILED: t(i18n)`Error al conectar con el servidor SFTP`,
    CRITICAL_NO_INTEGRATION_DATA: t(i18n)`No se encontraron datos de integración`,
    CRITICAL_NO_INFLUX_DEVICE_DATA: t(i18n)`No se encontraron datos del dispositivo en InfluxDB`,
  };

  if (code in map) return map[code as keyof typeof map];
  return code;
};
